import { useCallback } from "react";

import type { TriggerFn } from "@lexical/react/LexicalTypeaheadMenuPlugin";

export function useBasicTypeaheadTriggerMatch(
  trigger: string,
  {
    minLength = 1,
    maxLength = 75,
    ignorePunctuation,
  }: { minLength?: number; maxLength?: number; ignorePunctuation?: string },
): TriggerFn {
  const PUNCTUATION = ignorePunctuation || String.raw`\.,\+\*\?\$\@\|#{}\(\)\^\-\[\]\\/!%'"~=<>_:;`;

  return useCallback(
    (text: string) => {
      const validChars = `[^${trigger}${PUNCTUATION}\\s]`;
      // nosemgrep: javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp
      const TypeaheadTriggerRegex = new RegExp(
        `${String.raw`(^|\s|\()(`}[${trigger}]((?:${validChars}){0,${maxLength}}))$`,
      );
      const match = TypeaheadTriggerRegex.exec(text);
      if (match !== null) {
        const maybeLeadingWhitespace = match[1]!;
        const matchingString = match[3]!;
        if (matchingString.length >= minLength) {
          return {
            leadOffset: match.index + maybeLeadingWhitespace.length,
            matchingString,
            replaceableString: match[2]!,
          };
        }
      }
      return null;
    },
    [maxLength, minLength, trigger, PUNCTUATION],
  );
}
